module.exports = __webpack_public_path__ + "img/postback-step-5.ru.4482458e.jpg";